const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "min(90%, 438px)",
  bgcolor: "#1A1C21",
  boxShadow: 24,
  borderRadius: "19.58px",
  outline: "none",
}

export const returnStyle = (theme: string) => {
  if (theme === "dark") return style
  else return { ...style, bgcolor: "#ffffff" }
}

export const title =
  "text-black dark:text-brightWhite font-[500] text-sm text-center"

export const desc =
  "mt-1.5 md:mt-3 text-xs text-black dark:text-brightWhite text-center"

export const btnsParent =
  "mt-5 md:mt-[32px] flex justify-between items-center gap-4 md:gap-6"

export const leftBtn =
  "py-2 md:py-3.5 flex-1 font-[400] text-sm md:text-base border-[0.82px] border-newDarkBlack dark:border-golden rounded-xl text-newDarkBlack dark:text-golden transition-all duration-200 ease-linear"

export const rightBtn =
  "py-2 md:py-3.5 flex-1 font-[400] text-sm md:text-base border-[0.82px] border-newDarkBlack dark:border-golden rounded-xl bg-newDarkBlack dark:bg-golden text-white dark:text-blackish transition-all duration-200 ease-linear"
